import { LotDimension } from '@root/search/models/map.models';
import { getMapLabel } from '@shared/utils/map-label';
import { google as googleModel, MapLabel, MapLabelOptions } from '@shared/models/googlemaps.model';
import { PARCEL_BOUNDARY_STYLE } from '@root/search/models/map.constants';
import { MapUtils } from '@shared/utils/map-utils';
declare const google: any;

let labels: Array<MapLabel> = [];
let polygon: googleModel.maps.Polygon;

export function showLotDimensions(lotDimensions: Array<LotDimension>, map: googleModel.maps.Map): void {
  hideLotDimensions();

  const paths: Array<Array<googleModel.maps.LatLng>> = [];
  const bounds = new google.maps.LatLngBounds();

  lotDimensions.forEach((lotDimension: LotDimension) => {
    const labelText = lotDimension.lineLength.toFixed(0) + '\'';
    const labelPosition = new google.maps.LatLng(lotDimension.lineCtr.latitude, lotDimension.lineCtr.longitude);

    labels.push(getMapLabel({
      text: labelText,
      position: labelPosition,
      map
    } as MapLabelOptions));

    const startPoint = new google.maps.LatLng(lotDimension.lineStart.latitude, lotDimension.lineStart.longitude);
    const endPoint = new google.maps.LatLng(lotDimension.lineEnd.latitude, lotDimension.lineEnd.longitude);

    bounds.extend(startPoint);
    bounds.extend(endPoint);

    paths.push([
      startPoint,
      endPoint
    ]);
  });
  const options: googleModel.maps.PolygonOptions = {
    ...PARCEL_BOUNDARY_STYLE,
    map,
    paths
  };

  map.fitBounds(bounds);
  polygon = new google.maps.Polygon(options);
}

export function drawParcelBoundary(geometryList: Array<Array<string>>,  map: googleModel.maps.Map): void {
  hideLotDimensions();
  // Each entry in geometryList is a separate ring/polygon of the parcel geometry
  // (a WKT MULTIPOLYGON is expanded by the backend into one entry per polygon).
  // Keep them as distinct paths so multi-polygon parcels - e.g. duplicate parcel
  // polygons that share the same APN - render as separate closed loops. Flattening
  // them into a single path welds the last vertex of one polygon to the first vertex
  // of the next, producing spurious boundary connections across unrelated parcels.
  const paths = (geometryList || [])
    .map((geometry) => MapUtils.getPolygonPoints(geometry))
    .filter((points) => points.length > 0);

  const options: googleModel.maps.PolygonOptions = {
    ...PARCEL_BOUNDARY_STYLE,
    map,
    paths
  };

  polygon = new google.maps.Polygon(options);
}

export function hideLotDimensions() {
  labels.forEach((label: MapLabel) => label.setMap(null));
  labels = [];

  if (polygon) {
    polygon.setMap(null);
  }
}
